import { render, staticRenderFns } from "./indexPhone.vue?vue&type=template&id=5b9076b8&scoped=true&"
import script from "./indexPhone.vue?vue&type=script&lang=js&"
export * from "./indexPhone.vue?vue&type=script&lang=js&"
import style0 from "./indexPhone.vue?vue&type=style&index=0&id=5b9076b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9076b8",
  null
  
)

export default component.exports